import { ASSETS } from 'constants/assets'
import { LVG_ORDER_STATE } from 'constants/games/lvg/lvgOrderState'
import { useCallback, useMemo, useState } from 'react'
import { YourBidsCSS } from './YourBidsCSS.styled'
import { YourBidsRow } from './YourBidsRow'
import { useYourBidsOrders } from 'hooks/games/lvg/useYourBidsOrders'

const COLUMNS = [
  { id: '0', header: 'Status', headerClass: 'status', orderField: 'updatedAt' },
  { id: '1', header: 'Asset', headerClass: 'asset', orderField: 'asset' },
  { id: '2', header: 'Entry', headerClass: 'entry', orderField: 'entryPrice' },
  { id: '3', header: 'Bid', headerClass: 'bidamount', orderField: 'amount' },
  // { id: '4', header: 'Fee', headerClass: 'upFrontFees', orderField: '' },
  { id: '4', header: 'Funding Fee', headerClass: 'upFrontFees', orderField: '' },
  { id: '5', header: 'Bust', headerClass: 'bust', orderField: 'bustPrice' },
  { id: '6', header: 'X', headerClass: 'multiplier', orderField: 'leverage' },
  { id: '7', header: 'Exit', headerClass: 'exit', orderField: 'exitPrice' },
  { id: '8', header: 'TP/SL/TS', headerClass: 'tpsl', orderField: '' },
  { id: '10', header: 'P&L', headerClass: 'pandl', orderField: 'pnl' },
  { id: '11', header: 'ROI', headerClass: 'roi', orderField: '' },
  { id: '12', header: '', headerClass: 'share_bid', orderField: '' },
  { id: '13', header: '', headerClass: 'action_status', orderField: '' },
  { id: '14', header: '', headerClass: 'bid_cloning_ind', orderField: '' },
]

export const YourBids = () => {
  const [sortBy, setSortBy] = useState({ fieldId: 'updatedAt', isSortUp: true })
  const { yourBidsOrders } = useYourBidsOrders()
  const getAssetId = (assetId) => {
    return ASSETS.find((asset) => asset.id === assetId)?.name
  }

  const sortedData = useMemo(() => {
    const sortArray2 = (array) => {
      let itemA, itemB
      return array.sort((a, b) => {
        switch (sortBy.fieldId) {
          case 'asset':
            itemA = getAssetId(a[sortBy.fieldId])
            itemB = getAssetId(b[sortBy.fieldId])
            break
          default:
            itemA = a[sortBy.fieldId]
            itemB = b[sortBy.fieldId]
        }
        if (itemA < itemB) return sortBy.isSortUp ? 1 : -1
        if (itemA > itemB) return sortBy.isSortUp ? -1 : 1
        return 0
      })
    }
    const pendingOrders = yourBidsOrders.filter((order) => order.status === LVG_ORDER_STATE.PENDING)
    const sortedPendingOrders = sortArray2(pendingOrders)

    const liveOrders = yourBidsOrders.filter(
      (order) => order.status === LVG_ORDER_STATE.LIVE || order.status === LVG_ORDER_STATE.CLOSING
    )
    const sortedLiveOrders = sortArray2(liveOrders)

    const restOrders = yourBidsOrders.filter(
      (order) =>
        order.status !== LVG_ORDER_STATE.PENDING &&
        order.status !== LVG_ORDER_STATE.LIVE &&
        order.status !== LVG_ORDER_STATE.CLOSING
    )

    const sortedRestOrders = sortArray2(restOrders).slice(0, 100)

    return [...sortedPendingOrders, ...sortedLiveOrders, ...sortedRestOrders]
  }, [yourBidsOrders, sortBy])

  const sortColumn = useCallback((fieldId) => setSortBy((prev) => ({ fieldId, isSortUp: !prev.isSortUp })), [])

  return (
    <YourBidsCSS>
      <div className='panel' id='one-panel'>
        <div className='table_wrapper'>
          <div className='grid-body your_bids_iw'>
            <div className='grid-header'>
              {COLUMNS.map((column) => (
                <label className={column.headerClass}>
                  <span>{column.header}</span>
                  {/* {column.header && column.orderField && (
                    <div className='menu_select' onClick={() => sortColumn(column.orderField)} />
                  )} */}
                </label>
              ))}
            </div>
            <div className='grid-content'>
              {sortedData.map((order) => (
                <YourBidsRow order={order} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </YourBidsCSS>
  )
}
